export const Logo = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
    <rect x="0.5" y="0.5" width="31" height="31" rx="5" fill="#0A0D14" stroke="#334155" />
    <path d="M8 7v18h8" stroke="#F8FAFC" strokeWidth="3" strokeLinecap="square" />
    <circle cx="22" cy="12" r="5" stroke="#10B981" strokeWidth="2.5" />
    <circle cx="22" cy="12" r="1.6" fill="#10B981" />
    <path d="M19.5 25h5" stroke="#10B981" strokeWidth="3" />
  </svg>
);
